import React, { createContext, useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { getUrlParamByName, getVoltronBase, isCNTLD } from "./utils/helpers";
import PrivacySettingsLayout from "./components/Layouts/PrivacySettingsLayout";
import GTCLayout from "./components/Layouts/GTCLayout";
import Spinner from "./components/UI/Spinner/Spinner";

export const AppContext = createContext({});

const App = (props) => {
  const locale =
    getUrlParamByName(location.search, "locale") ||
    getUrlParamByName(location.search, "ui_locales") ||
    "en_US";
  useEffect(() => {
    document.documentElement.setAttribute(
      "lang",
      locale.toLocaleLowerCase().replace("_", "-")
    );
  }, []);

  return (
    <Router basename="/consent/">
      <Switch>
        <Route
          path="/gtc"
          render={(props) => <GTCLayout {...props} locale={locale} />}
        />
        <Route
          path="/"
          render={(props) => (
            <PrivacySettingsLayout {...props} locale={locale} />
          )}
        />
      </Switch>
    </Router>
  );
};
export default App;
